module.exports = __webpack_public_path__ + "img/edit.1b598c2a.svg";